import { FILTERS, FINANCIAL, INNOVATIONS } from 'translations';
import { FINANCIAL_PUBLICATION as TYPE_FINANCIAL_PUBLICATION } from '../types/filters';

const PRISMIC_INNO_STATUS = {
  TEST: 'En test',
  WORKING: 'En place',
};

export const MAPPING_INNO_STATUS = {
  [PRISMIC_INNO_STATUS.TEST]: INNOVATIONS.INNO_TEST,
  [PRISMIC_INNO_STATUS.WORKING]: INNOVATIONS.INNO_WORKING,
};

export const MAPPING_PERIODS = {
  THIS_WEEK: FILTERS.THIS_WEEK,
  THIS_MONTH: FILTERS.THIS_MONTH,
  NEXT_WEEK: FILTERS.NEXT_WEEK,
  NEXT_MONTH: FILTERS.NEXT_MONTH,
};

export const MAPPING_PUBLICATIONS_TYPES = {
  [FINANCIAL.FIN_PUBLICATION_YEARLY_RESULTS]:
    TYPE_FINANCIAL_PUBLICATION.FULL_YEAR_RESULTS,
  [FINANCIAL.FIN_PUBLICATION_REFS]:
    TYPE_FINANCIAL_PUBLICATION.REFERENCE_DOCUMENT,
  [FINANCIAL.FIN_PUBLICATION_URD]: TYPE_FINANCIAL_PUBLICATION.URD,
  [FINANCIAL.FIN_PUBLICATION_BIANNUAL]: TYPE_FINANCIAL_PUBLICATION.HALF_RESULTS,
  [FINANCIAL.FIN_PUBLICATION_INVESTORS]:
    TYPE_FINANCIAL_PUBLICATION.INVESTOR_PRESENTATIONS,
  [FINANCIAL.FIN_PUBLICATION_RSE]: TYPE_FINANCIAL_PUBLICATION.RSE_REPORT,
  [FINANCIAL.FIN_PUBLICATION_GREEN_BOND]: TYPE_FINANCIAL_PUBLICATION.GREEN_BOND,
};
